import { render, staticRenderFns } from "./iconBtn.vue?vue&type=template&id=18988bc3&scoped=true"
import script from "./iconBtn.vue?vue&type=script&lang=js"
export * from "./iconBtn.vue?vue&type=script&lang=js"
import style0 from "./iconBtn.vue?vue&type=style&index=0&id=18988bc3&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18988bc3",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins_home/workspace/compass-html-develop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('18988bc3')) {
      api.createRecord('18988bc3', component.options)
    } else {
      api.reload('18988bc3', component.options)
    }
    module.hot.accept("./iconBtn.vue?vue&type=template&id=18988bc3&scoped=true", function () {
      api.rerender('18988bc3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/iconBtn.vue"
export default component.exports